import http, {makeSearchParams} from 'utils/http';

export const getBranches = (data) => {
  return http('GET', 'branches', makeSearchParams(data));
};

export const getPublicBranchesByAb = (id, data) => {
  return http('GET', `g/ab/${id}/branches`, makeSearchParams(data));
};

export const getPublicBranchesByCb = (id, data) => {
  return http('GET', `g/cb/${id}/branches`, makeSearchParams(data));
};
